/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { UserPage } from '../../components/UserPage';

function ManageAdminsPage() {
  return <UserPage userRole="admin" />;
}

export default ManageAdminsPage;
